import { useCallback, useState } from 'react'

export const useForceRerender = () => {
  const [tick, setTick] = useState(0)

  const forceRerender = useCallback(() => setTick((tick) => tick + 1), [])

  return { forceRerender, tick }
}
